package org.gstechnovos.jexonplastech.sections.products.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.gstechnovos.jexonplastech.sections.products.styles.FilterButtonStyle
import org.gstechnovos.jexonplastech.sections.products.styles.FilterContainerStyle
import org.gstechnovos.jexonplastech.sections.products.styles.SearchInputStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text

// ==========================================
// CMS DATA MODEL
// ==========================================
/**
 *
 * Text Constraints:
 *
 * Headline: Renders at 20px in bold font. Limit to 2–4 words (e.g., "Filter by Category").
 *
 * Category Names: Keep category names (e.g., "Cleaning Brushes", "Floor Wipers") short,
 * ideally 1–3 words. If category names are too long, the buttons will become excessively wide
 * and stack awkwardly on mobile devices.
 *
 */
// ==========================================
// CMS DATA MODEL
// ==========================================
data class ProductsFilterData(
    val headline: String, val categories: List<String>
)

val defaultProductsFilterData = ProductsFilterData(
    headline = "Products", categories = listOf(
        "All",
        "Cleaning Brushes",
        "Toilet Brushes",
        "Floor Wipers",
        "Brooms & Dusters",
        "Dust Pans",
        "Baskets & Accessories",
        "Specialized"
    )
)

// ==========================================
// COMPONENT
// ==========================================
@Composable
fun ProductsFilterSection(
    data: ProductsFilterData = defaultProductsFilterData,
    selectedCategory: String = "All",
    onCategorySelect: (String) -> Unit = {},
    searchQuery: String = "",
    onSearchChange: (String) -> Unit = {}
) {
    val palette = ColorMode.current.toSitePalette()

    Column(
        modifier = FilterContainerStyle.toModifier().padding(leftRight = 5.percent),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (data.headline.isNotEmpty()) {
            SpanText(
                text = data.headline,
                modifier = Modifier.color(palette.brand.primaryBlue).fontSize(36.px).fontWeight(FontWeight.Bold)
                    .margin(topBottom = 24.px)
            )
        }

        // --- NEW: SEARCH BAR ---
        Input(
            type = InputType.Text,
            attrs = SearchInputStyle.toModifier() // This applies the visible border
                .fillMaxWidth()
                .maxWidth(500.px)
                .padding(14.px)
                .margin(bottom = 28.px)
                .borderRadius(8.px)
                .fontSize(18.px)
                .toAttrs {
                    attr("placeholder", "Search products by name or model...")
                    value(searchQuery)
                    onInput { e -> onSearchChange(e.value) }
                }
        )

        // --- CATEGORY PILLS ---
        Row(
            modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap).gap(16.px),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            data.categories.forEach { category ->
                val isActive = category == selectedCategory

                Button(
                    attrs = FilterButtonStyle.toModifier().borderRadius(12.px).then(
                        if (isActive) {
                            Modifier.backgroundColor(palette.brand.primaryBlue).color(palette.custom.white)
                        } else Modifier
                    ).onClick { onCategorySelect(category) }.toAttrs()
                ) {
                    Text(category)
                }
            }
        }
    }
}